module.exports = __webpack_public_path__ + "static/media/kitchen-5.d57bf1c3.jpg";